import http from "@/services/http";
import httpForm from "@/services/httpForm";

export const tenant = () => {
  async function getOne() {
    const {data} = await http.get('/tenant/getOne');
    return data;
  }

  async function update(dados) {
    const response = await http.post('/tenant/edit', dados);
    return response.data;
  }

  // Foto de perfil (logo) da empresa
  async function uploadLogo(arquivo) {
    const form = new FormData();
    form.append('logo', arquivo);
    const response = await httpForm.post('/tenant/logo', form);
    return response.data;
  }

  return {getOne, update, uploadLogo};
}
